export default "__VITE_ASSET__DkgWnZHJ__"